export default "__VITE_ASSET__25803e7d__"